import { FC, Fragment } from "react";
import { Box, Typography } from "@mui/material";
import { CMTabSelectedEnrollmentType } from "DataTypes/Modal";
import { useDispatch } from "react-redux";
import { addSelectedPrgm } from "Redux/Patient/Action";
import { useNavigate } from "react-router-dom";
import { RouteUrls } from "Constant/RouteUrls";
import { selectedPrgmInitialState } from "Redux/Patient/reducer";
import { PatientInitialStateType, UserInitialStateType } from "DataTypes/Redux";
import { useSelector } from "react-redux";
import { CommonStyle, ReusableCTUI } from "Components";
import CstmIconBtn from "Components/CstmIconBtn";
import ImgPath from "Constant/Imgs";
import PatientFormatter from "Utils/Patient.Formatter";
import Stages from "Constant/Stages";

const CareTeam: FC<CMTabSelectedEnrollmentType> = ({
  prgmDetails,
  onClose,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { patientInfo, ehr }: PatientInitialStateType = useSelector(
    (state: any) => state?.patient
  );
  const { myInfo }: UserInitialStateType = useSelector(
    (state: any) => state?.user
  );
  const isAdmin = myInfo.roleId == 1 || myInfo.roleId == 2;
  const recurringStage = PatientFormatter.GetCPStage(Stages.Recurring);
  const currentStage = prgmDetails.careplanStage;

  const handleEditTeam: () => void = () => {
    onClose && onClose();
    dispatch(
      addSelectedPrgm({ ...selectedPrgmInitialState, ...prgmDetails })
    );
    navigate(
      `/${RouteUrls.hs}/${RouteUrls.patient}/${patientInfo.id}/` +
      `${RouteUrls.carePlan}/${prgmDetails.careplanId}/${RouteUrls.editTeam}`
    );
  };

  return (
    <Fragment>
      <Box
        height="10%"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography sx={{ ...CommonStyle.sxHeading }}>
          {`${prgmDetails.abbrevation} Team`}
        </Typography>
        {ehr.vendor === null &&
          prgmDetails.status == "Enrolled" &&
          ((prgmDetails.teamMember && currentStage == recurringStage) ||
            isAdmin
          ) && (
          <CstmIconBtn
            icon={<ImgPath.EditOutlined />}
            onClick={handleEditTeam}
            title="Edit"
          />
        )}
      </Box>
      <Box overflow={"auto"} height="88%" sx={{ "&>div": { width: "100%" } }}>
        <ReusableCTUI
          addAddProviders={false}
          displayNextBtn={false}
          displaySaveBtn={false}
          displaySaveNextBtn={false}
          editAddProviders={false}
          openAllForSA={false}
          prgmDetails={prgmDetails}
          editCareTeam={false}
          filterForm1EmptyFields={true}
          filterForm2EmptyFields={true}
        />
      </Box>
    </Fragment>
  );
};
export default CareTeam;
